import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import classNames from 'classnames';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { type Control, Controller } from 'react-hook-form';

import type { ControlSize } from './ControlSize.ts';
import { CountryPicker } from './CountryPicker.tsx';
import { ValidationViolation } from './ValidationViolation.tsx';

// --- Types and Components for Form Structure ---

type InputProps<Element = InputHTMLAttributes<HTMLInputElement>> = Element & {
    label: string;
    value?: string;
    onChange?: (value?: string) => void;
    error?: string | string[] | false;
    iconName?: string;
    className?: string;
    size?: ControlSize;
    name: string;
    // biome-ignore lint/suspicious/noExplicitAny: <react-hook-form> types
    control?: Control<any>;
    action?: ReactNode;
    formGroupClassName?: string;
    addon?: string;
    flavor?: 'default' | 'error';
};

export const ControlledCountryPicker = ({ name, control, ...props }: InputProps) => {
    return (
        <Controller
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <FormCountryPicker {...props} {...field} error={error?.message} />
            )}
            name={name}
            control={control}
        />
    );
};

const FormCountryPicker = ({
    label,
    value,
    onChange,
    error,
    className,
    iconName,
    size,
    action,
    formGroupClassName,
    addon,
    ...props
}: InputProps) => {
    const id = `form_id__${props.name}`;
    const hasViolation = !!error;
    return (
        <div
            className={classNames('form-group', formGroupClassName, {
                'has-error': hasViolation,
                'has-feedback': hasViolation,
            })}
        >
            <FormLabel>{label}</FormLabel>
            <div className='form-control-feedback-wrapper'>
                <div className='input-group'>
                    <CountryPicker value={value} onChange={onChange} className={className} id={id} {...props} />
                </div>
                <ValidationViolation violations={error} />
            </div>
        </div>
    );
};
